@if (isMatListItem() === false) {
  <mat-form-field appearance="outline" class="flex-1">
    <mat-label>{{label()}}</mat-label>
    <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="notaryAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
    <div matSuffix="" class="flex items-center">
      @if (isLoadingNotaries) {
        <mat-spinner diameter="14" class="mx2"></mat-spinner>
      } @else {
        <button type="button" (click)="refreshNotaries(); $event.stopPropagation();" mat-icon-button="" color="primary">
          <mat-icon>refresh</mat-icon>
        </button>
      }
    </div>
    <mat-autocomplete class="extendable-autocomplete" #notaryAutoComplete="matAutocomplete" [displayWith]="displayWithNotary">
      @if (required() === false) {
        <mat-option [value]="null">
          <span translate="">None</span>
        </mat-option>
      }
      @for (notary of notariesFiltered; track notary) {
        <mat-option [value]="notary">
          <span class="inline-autocomplete-option">
            <span>{{notary.name}}</span>
            -
            <span class="gray">{{notary.address.city}}</span>
          </span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
} @else {
  <mat-list-item>
    <label>{{label()}}</label>
    <mat-form-field floatLabel="never" class="inline-field">
      <div matSuffix="" class="flex items-center">
        @if (isLoadingNotaries === true) {
          <mat-spinner diameter="14" class="mx2"></mat-spinner>
        }
      </div>
      <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="notaryAutoComplete" (keypress)="doFilter($event.target.value)" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
      <mat-autocomplete class="inline-autocomplete extendable-autocomplete" #notaryAutoComplete="matAutocomplete" [displayWith]="displayWithNotary">
        @if (required() === false) {
          <mat-option [value]="null">
            <span translate="">None</span>
          </mat-option>
        }
        @for (notary of notariesFiltered; track notary) {
          <mat-option [value]="notary">
            <span class="inline-autocomplete-option">
              <span>{{notary.name}}</span>-
              <span class="gray">{{notary.address.city}}</span>
            </span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </mat-list-item>
}
